module.exports = __webpack_public_path__ + "media/img/auth/campus-cap-registration-d3b8458e32110d6c55e3dc72960a7e4c.jpg";